import toast from 'react-hot-toast';

const modalNotification = ({
  type,
  message,
}) => {
  if (typeof window === "undefined") return;

  switch (type) {
    case 'success':
      toast.success(message);
      break;
    case 'error':
      toast.error(message);
      break;
    case 'warning':
      toast(message, {
        icon: '⚠️',
      });
      break;
    case 'info':
      toast(message, {
        icon: 'ℹ️',
      });
      break;
    default:
      toast(message);
      break;
  }
};

export default modalNotification;